<mat-form-field
  appearance="outline"
  class="{{ formFieldClass }} phone-input-field"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    label | translate
  }}</mat-label>
  <button
    mat-button
    matPrefix
    [matMenuTriggerFor]="menu"
    type="button"
    class="prefix-selector"
  >
    <span *ngIf="selectedPrefix" class="prefix-container">
      <span class="flag-icon">{{ selectedPrefix.flag }}</span>
      <span class="prefix-number">+{{ selectedPrefix.prefix }}</span>
    </span>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-menu #menu="matMenu" class="phone-prefix-menu">
    <button
      mat-menu-item
      *ngFor="let prefix of COUNTRY_PREFIXES"
      (click)="onPrefixSelected(prefix)"
    >
      <span>{{ prefix.flag }} {{ prefix.name }} (+{{ prefix.prefix }})</span>
    </button>
  </mat-menu>

  <input
    matInput
    type="tel"
    [formControl]="control"
    (input)="onPhoneInput($event)"
    [readonly]="readonly"
  />

  <mat-error
    *ngIf="control.invalid && control.touched && required && !readonly"
  >
    {{ "hotels.required-phone" | translate }}
  </mat-error>
</mat-form-field>
